module.exports = __webpack_public_path__ + "static/media/cardView.8bb6e233.svg";